import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  selectPlatformHeadingNext: {
    id: "funding-application: select platform heading next",
    defaultMessage: "Select all your platforms",
  },
  selectPlatformDescriptionNext: {
    id: "funding-application: select platform description next",
    defaultMessage:
      "Identify all platforms that you use to run your business to speed up your application and unlock the best offers.",
  },

  // New connections & data page messages
  connectionsAndDataHeading: {
    id: "funding-application: connections and data heading",
    defaultMessage: "Connections and data",
  },

  // Dynamic subtitle for connections page
  connectionsSubtitleWithActions: {
    id: "funding-application: connections subtitle with actions",
    defaultMessage:
      "Add the platforms you use to run your business. Next, you'll {nextActions} so we can start building your offer.",
  },
  connectionsSubtitleNoActions: {
    id: "funding-application: connections subtitle no actions",
    defaultMessage: "Add the platforms you use to run your business so we can start reviewing your application.",
  },
  nextActionBanking: {
    id: "funding-application: next action banking",
    defaultMessage: "connect your bank account",
  },
  nextActionSusa: {
    id: "funding-application: next action susa",
    defaultMessage: "upload your SUSA",
  },
  nextActionPoolBancario: {
    id: "funding-application: next action pool bancario",
    defaultMessage: "upload your Pool Bancario",
  },
  nextActionCashFlow: {
    id: "funding-application: next action cash flow",
    defaultMessage: "provide your revenue projections",
  },
  nextActionCreditCheck: {
    id: "funding-application: next action credit check",
    defaultMessage: "complete a credit check",
  },

  // Continue button label
  continueApplicationLabel: {
    id: "funding-application: continue application button label",
    defaultMessage: "Continue",
  },
  connectBankAccountsCta: {
    id: "funding-application: connect bank accounts cta",
    defaultMessage: "Connect bank accounts",
  },

  // platform categories
  onlineSalesPlatformCategory: {
    id: "funding-application: online sales platform category next",
    defaultMessage: "Online sales",
  },
  eCommercePlatformCategory: {
    id: "funding-application: ecommerce platform category next",
    defaultMessage: "eCommerce",
  },
  marketingPlatformCategory: {
    id: "funding-application: marketing platform category next",
    defaultMessage: "Marketing",
  },
  marketingAnalyticsPlatformCategory: {
    id: "funding-application: marketing analytics platform category next",
    defaultMessage: "Marketing and analytics",
  },
  accountingPlatformCategory: {
    id: "funding-application: accounting platform category next",
    defaultMessage: "Accounting",
  },
  accountingPlatformOtherSoftware: {
    id: "funding-application: accounting platform other software",
    defaultMessage: "Other software...",
  },
  paymentsPlatformCategory: {
    id: "funding-application: payments platform category next",
    defaultMessage: "Payments",
    description: "Title of a section listing payment platforms customers can connect",
  },
  primaryPlatformSelectedHelperText: {
    id: "funding-application: primary platform selected helper text",
    defaultMessage: "Since you've selected {platformName}, connecting Stripe or Google Analytics isn't required.",
  },
  onlineSalesCategoryDescription: {
    id: "funding-application: online sales category description",
    defaultMessage: "Select the online sales platform(s) you use below.",
  },
  accountingCategoryDescription: {
    id: "funding-application: accounting category description",
    defaultMessage: "Select the accounting platform(s) you use below.",
  },
  marketingCategoryDescription: {
    id: "funding-application: marketing category description",
    defaultMessage: "Select the marketing platform(s) you use below.",
  },
  startApplicationLabel: {
    id: "funding-application: start application",
    defaultMessage: "Start Application",
  },
  addAnotherPlatform: {
    id: "funding-application: add another platform title",
    defaultMessage: "Add another platform",
  },
  addCustomPlatform: {
    id: "funding-application: add custom platform button",
    defaultMessage: "Add custom",
    description:
      "Shows up when customer tries to add a platform we don't know about and allows customer to save that platform",
  },
  addAnotherPlatformCancel: {
    id: "funding-application: add another platform button cancel",
    defaultMessage: "Cancel",
    description: "Cancel button if customer does not wish to add another platform",
  },
  unsupportedPlatformNameError: {
    id: "funding-application: add another platform error",
    defaultMessage: "Please choose platform or add custom platform name",
    description: "Error message if customer does not choose or type a platform option",
  },

  // Platform selection validation errors
  missingRevenueMarketingAndAccounting: {
    id: "funding-application: missing revenue marketing and accounting error",
    defaultMessage:
      "To help us accurately assess your funding eligibility and proceed with your application, please add accounting data, and connect a marketing and online sales platform.",
  },
  missingRevenueAndAccounting: {
    id: "funding-application: missing revenue platform and accounting data error",
    defaultMessage:
      "To help us accurately assess your funding eligibility and proceed with your application, please add accounting data and connect an online sales platform.",
  },
  missingRevenueAndMarketing: {
    id: "funding-application: missing revenue and marketing platforms error",
    defaultMessage:
      "To help us accurately assess your funding eligibility and proceed with your application, please connect a marketing and online sales platform.",
  },
  missingMarketingAndAccounting: {
    id: "funding-application: missing marketing and accounting error",
    defaultMessage:
      "To help us accurately assess your funding eligibility and proceed with your application, please add accounting data and connect a marketing platform.",
  },
  missingRevenuePlatform: {
    id: "funding-application: missing revenue platform error",
    defaultMessage: "You must add an online sales platform that will give us visibility into your sales performance.",
  },
  missingMarketingPlatform: {
    id: "funding-application: missing marketing platform error",
    defaultMessage: "You must add a marketing platform in order for us to fully assess your eligibility for funding.",
  },
  missingAccountingData: {
    id: "funding-application: missing accounting data error",
    defaultMessage: "You must add accounting data in order for us to fully assess your eligibility for funding.",
  },

  // Platform not listed modal
  platformNotListedModalTitle: {
    id: "funding-application: platform not listed modal title",
    defaultMessage: "My platform isn't listed",
  },
  platformNotListedModalDescription: {
    id: "funding-application: platform not listed modal description",
    defaultMessage:
      "To process your application faster, we recommend connecting an online sales platform. <br></br>This provides us with the most comprehensive data and helps us maximise the funding we can offer you.",
  },
});
